import { Component } from '@angular/core';

@Component({
  selector: 'app-total-points-circles-background',
  templateUrl: './total-points-circles-background.component.html',
  styleUrls: ['./total-points-circles-background.component.scss']
})
export class TotalPointsCirclesBackgroundComponent {}
